import { createVuetify } from 'vuetify';
import { en, de, ko } from 'vuetify/locale';
import theme from './theme';

import { aliases, custom } from '@/iconsets/custom';
import { mdi } from 'vuetify/iconsets/mdi';
import vuetifyDefaults from './vuetify-defaults';

const vuetify = createVuetify({
  theme: {
    defaultTheme: theme.defaultTheme,
    themes: theme.themes,
  },
  locale: {
    locale: 'en',
    messages: { en, de, ko },
  },
  icons: {
    defaultSet: 'mdi', // use MDI as default
    aliases: {
      ...aliases, // your custom aliases
    },
    sets: {
      custom, // your custom set
      mdi, // MDI set
    },
  },
  // Default props for Vuetify components are imported from a separate file for easier maintenance
  defaults: vuetifyDefaults,
});

export default vuetify;
